import { Link } from 'react-router-dom';
import { getCategories, getArticlesByCategory, buildCategoryPath } from '@/utils/articles';

const toneMap: Record<string, { card: string; icon: string }> = {
  'mingxing-bagua': { card: 'bg-primary-50 border-primary-100', icon: 'bg-primary-500 text-background-50' },
  'wanghong-fanche': { card: 'bg-accent-50 border-accent-100', icon: 'bg-accent-500 text-background-50' },
  'suran-tougao': { card: 'bg-secondary-50 border-secondary-100', icon: 'bg-secondary-500 text-background-50' },
  'quannei-neimu': { card: 'bg-foreground-50 border-foreground-100', icon: 'bg-foreground-800 text-background-50' },
};

export default function CategoryGrid() {
  const categories = getCategories();

  return (
    <section className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-14" aria-label="主题分类">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((category) => {
          const tone = toneMap[category.slug] || {
            card: 'bg-background-100 border-background-200',
            icon: 'bg-foreground-800 text-background-50',
          };
          const count = getArticlesByCategory(category.slug).length;
          return (
            <Link
              key={category.slug}
              to={buildCategoryPath(category.slug)}
              className={`group flex flex-col gap-3 rounded-xl border p-5 transition-transform duration-300 hover:-translate-y-1 ${tone.card}`}
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-lg text-xl ${tone.icon}`}>
                <i className={category.icon} />
              </span>
              <h3 className="font-heading text-lg font-bold text-foreground-950">{category.name}</h3>
              <p className="line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">{category.description}</p>
              <div className="flex items-center justify-between text-xs text-foreground-500">
                <span>共 {count} 篇爆料</span>
                <span className="flex items-center gap-1 font-medium text-foreground-700 transition-colors group-hover:text-primary-600">
                  查看
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}